import React, { useState } from 'react';
import './NewCategoria.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import baseURL from '../../url';

export default function NewCategoria() {
    const [mensaje, setMensaje] = useState('');
    const [categoria, setCategoria] = useState('');
    const [discountOne, setDiscountOne] = useState(0);
    const [discountTwo, setDiscountTwo] = useState(0);
    const [discountThree, setDiscountThree] = useState(0);
    const [discountFour, setDiscountFour] = useState(0);
    const [modalOpen, setModalOpen] = useState(false);

    const toggleModal = () => {
        setCategoria('');
        setMensaje('');
        setModalOpen(!modalOpen);
    };


    const crear = async () => {
        const formData = new FormData();
        formData.append('categoria', categoria);
        formData.append('discountOne', discountOne);
        formData.append('discountTwo', discountTwo);
        formData.append('discountThree', discountThree);
        formData.append('discountFour', discountFour);

        setMensaje('Procesando...');

        try {
            const response = await fetch(`${baseURL}/categoriasPost.php`, {
                method: 'POST',
                body: formData,
            });

            const data = await response.json();

            if (data.mensaje) {
                setMensaje('');
                toast.success(data.mensaje);
                toggleModal();
                window.location.reload();
            } else if (data.error) {
                setMensaje('');
                toast.error(data.error);
            }
        } catch (error) {
            console.error('Error:', error);
            setMensaje('');
            toast.error('Error de conexión. Por favor, inténtelo de nuevo.');
        }
    };

    return (
        <div className='NewContain'>
            <ToastContainer />
            <button onClick={toggleModal} className='btnSave'>
                <span>+</span> Agregar
            </button>
            {modalOpen && (
                <div className='modal'>
                    <div className='modal-content'>
                        <div className='deFlexBtnsModal'>
                            <button className='selected'>Agregar Categoria</button>
                            <span className="close" onClick={toggleModal}>&times;</span>
                        </div>
                        <form id="crearForm">
                            <fieldset>
                                <legend>Categoría</legend>
                                <input
                                    type='text'
                                    name='categoria'
                                    value={categoria}
                                    onChange={(e) => setCategoria(e.target.value)}
                                />
                            </fieldset>
                            <div className='mayoreoContainer'>
                                <fieldset>
                                    <legend>Precio Mayoreo 200</legend>
                                    <input
                                        type='number'
                                        name='discountOne'
                                        value={discountOne}
                                        onChange={(e) => setDiscountOne(e.target.value)}
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Precio Mayoreo 100</legend>
                                    <input
                                        type='number'
                                        name='discountTwo'
                                        value={discountTwo}
                                        onChange={(e) => setDiscountTwo(e.target.value)}
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Precio Mayoreo 50</legend>
                                    <input
                                        type='number'
                                        name='discountThree'
                                        value={discountThree}
                                        onChange={(e) => setDiscountThree(e.target.value)}
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Precio Mayoreo 30</legend>
                                    <input
                                        type='number'
                                        name='discountFour'
                                        value={discountFour}
                                        onChange={(e) => setDiscountFour(e.target.value)}
                                    />
                                </fieldset>
                            </div>

                            {mensaje ? (
                                <button type='button' className='btnLoading' disabled>
                                    {mensaje}
                                </button>
                            ) : (
                                <button type='button' onClick={crear} className='btnPost'>
                                    Agregar
                                </button>
                            )}
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}
